import { Col, Row } from "reactstrap";

const CaracteristicasGenerales = () => {
  return (
    <Row className="p-2">
      <Col xs={12} sm={6} className="px-5 mt-5">
        <p className="font-weight-bold">Máxima rentabilidad</p>
        <ul class="mt-3">
          <li>Hasta un 25% mas de energía que un sistema fijo</li>
          <li>Ocupación de parcela un 30% superior a un sistema fijo</li>
          <li>Sólo 10% menos de energía frente sistema de doble eje</li>
          <li>
            Bajo sobrecoste respecto estructuras fijas, muy inferior a un doble
            eje
          </li>
          <li>
            {" "}
            Eliminación de las sombras parciales con el sistema de Backtracking
          </li>
        </ul>
        <hr />
        <p className="font-weight-bold">Simplicidad y gran eficiencia</p>
        <ul class="mt-3">
          <li>
            Sistema de anclaje al suelo por tornillos de acero, libre de
            hormigón
          </li>
          <li>Cableado por la estructura, reducimos al máximo la obra civil</li>
          <li>Montaje rápido y mantenimiento mínimo</li>
          <li>Gran superfície de paneles con un solo accionamiento</li>
          <li>Estructura con resistencia al viento sobresaliente</li>
        </ul>
      </Col>

      <Col xs={12} sm={6} className="px-5 mt-5">
        <p className="font-weight-bold">Diseño y fabricación propia</p>
        <ul class="mt-3">
          <li>
            Seguidor solar patentado por Avantsolar. Número patente: 1068574 Y
          </li>
          <li>
            Flexibilidad para ajustar la fabricación del seguidor a los
            requerimientos del proyecto.
          </li>
          <li>
            Sistema de monitorización inalámbrico desarrollado exclusivamente
            por nosotros para nuestras máquinas.
          </li>
        </ul>
        <hr />
        <p className="font-weight-bold">Ingeniería y montaje</p>
        <ul class="mt-3">
          <li>
            Asesoramiento personalizado para optimizar su proyecto desde nuestra
            ingeniería.
          </li>
          <li>Proporcionamos nuestros seguidores montados y funcionando. </li>
          <li>
            Servicio post-venta para mantenimiento integral de la máquina.
          </li>
        </ul>
      </Col>
    </Row>
  );
};

export default CaracteristicasGenerales;
